// Plan credit limits for progress bar
export const PLAN_CREDITS = {
  none: 0,
  pro: 10,
};

// Plan repair history caps (all paid plans get unlimited history)
export const PLAN_HISTORY_CAPS = {
  none: 0,
  pro: Infinity,
};